export default function (groupId: number) {
  localStorage.setItem("groupId", groupId.toString());
}
